/**
 * Groups query hooks — fetch groups data via React Query.
 */
import { useQuery } from '@tanstack/react-query';
import GroupsAPI from '@/api/groups.api';

/** Fetch all groups for a user (or current user) */
export function useGroups(userId?: string) {
  return useQuery({
    queryKey: userId ? ['groups', userId] : ['groups'],
    queryFn: () => GroupsAPI.getMyGroups(userId),
    staleTime: 2 * 60 * 1000,
  });
}

/** Fetch a single group with student details */
export function useGroup(id: string | undefined) {
  return useQuery({
    queryKey: ['group', id],
    queryFn: () => GroupsAPI.getGroupWithStudents(id!),
    enabled: !!id,
    staleTime: 60 * 1000,
  });
}
